export default "__VITE_ASSET__ChYD4x8R__"